import { styled } from '../styles/index.js';

// Text Color
const colorVariant = ({ $color, $theme }) => {
  const colors = { ...$theme.palette, ...$theme.palette.common };
  const defaultColor = $color === 'default' ? 'corporate' : null;

  return {
    color: $color === 'inherit' ? 'inherit' : colors[defaultColor || $color],
  };
};

export const AnchorLabelRoot = styled('span', ({ $theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'inherit',
  ...$theme.typography.base,
}));

/** Base Anchor Component */
const AnchorRoot = styled('a', ({ $color, $theme }) => ({
  ...$theme.typography.base,
  display: 'inline-block',
  textDecoration: 'none',
  ...colorVariant({ $color, $theme }),
}));

export default AnchorRoot;
